module.exports = __webpack_public_path__ + "static/media/md-bluetooth.4bd9a202.svg";